import React from 'react';
import { AlertCircle, CheckCircle, Info, AlertTriangle } from 'lucide-react';

const Alert = ({ type = 'info', title, message, dismissible = false, onDismiss }) => {
  const styles = {
    info: {
      container: 'bg-blue-50 dark:bg-blue-900 border-blue-200 dark:border-blue-800',
      icon: 'text-blue-600 dark:text-blue-400',
      title: 'text-blue-900 dark:text-blue-100',
      message: 'text-blue-700 dark:text-blue-200',
      Icon: Info
    },
    success: {
      container: 'bg-success-50 dark:bg-success-900 border-success-200 dark:border-success-800',
      icon: 'text-success-600 dark:text-success-400',
      title: 'text-success-900 dark:text-success-100',
      message: 'text-success-700 dark:text-success-200',
      Icon: CheckCircle
    },
    warning: {
      container: 'bg-warning-50 dark:bg-warning-900 border-warning-200 dark:border-warning-800',
      icon: 'text-warning-600 dark:text-warning-400',
      title: 'text-warning-900 dark:text-warning-100',
      message: 'text-warning-700 dark:text-warning-200',
      Icon: AlertTriangle
    },
    error: {
      container: 'bg-error-50 dark:bg-error-900 border-error-200 dark:border-error-800',
      icon: 'text-error-600 dark:text-error-400',
      title: 'text-error-900 dark:text-error-100',
      message: 'text-error-700 dark:text-error-200',
      Icon: AlertCircle
    }
  };

  const style = styles[type] || styles.info;
  const { Icon } = style;

  return (
    <div className={`rounded-lg border p-4 ${style.container}`}>
      <div className="flex gap-3">
        <Icon className={`w-5 h-5 flex-shrink-0 mt-0.5 ${style.icon}`} />
        <div className="flex-1">
          {title && <h3 className={`font-medium ${style.title}`}>{title}</h3>}
          {message && <p className={`${title ? 'mt-1 text-sm' : ''} ${style.message}`}>{message}</p>}
        </div>
        {dismissible && onDismiss && (
          <button
            onClick={onDismiss}
            className={`flex-shrink-0 ${style.icon} hover:opacity-70 dark:hover:opacity-60 transition-opacity`}
            aria-label="إغلاق التنبيه"
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
};

export default Alert;
